/** Runtime configuration, injected at build time by Vite (import.meta.env.VITE_*). */
export const config = {
  env: import.meta.env.VITE_ENV,
  /** GCP API Gateway root (auth + ring-swap routes both live under it). */
  apiBase: import.meta.env.VITE_API_GATEWAY_ENDPOINT,
  clientId: import.meta.env.VITE_CLIENT_ID,
  redirect: import.meta.env.VITE_REDIRECT,
  /** Google Workspace domain admin reviewers must belong to. */
  adminDomain: "aardvarkjewellery.com",
  /** Path prefix this service is mounted under on the gateway (see aardvark-api-config). */
  ringSwapPrefix: "/ring-swap",
  /** Cloudinary cloud name — resolves products-api image `providerId`s to delivery URLs.
   * products-api exposes no URLs, only provider ids (test bench, products.ts). */
  cloudinaryCloud: import.meta.env.VITE_CLOUDINARY_CLOUD ?? "prod-aardvark-jewellery",
} as const;
